<template>
  <div class="modal-wrapper">
    <TransitionRoot as="template" :show="open">
      <Dialog class="fixed inset-0 z-50">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <div class="fixed inset-0 bg-gray-500/75 transition-opacity" />
        </TransitionChild>

        <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
              <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div>
                  <div class="flex justify-center items-center mb-6 p-20">
                    <div class="relative">
                      <div class="absolute animate-ping rounded-full border-4 border-blue-100 w-60 h-60 bg-blue-50 -z-20 -ml-20 -mt-20"></div>
                      <div class="absolute animate-ping rounded-full border-4 border-blue-100 w-40 h-40 bg-blue-50 -z-10 -ml-10 -mt-10"></div>
                      <div class="absolute animate-ping rounded-full border-4 border-blue-100 w-20 h-20 bg-blue-50 z-0"></div>
                      <div class="w-20 h-20 rounded-full bg-blue-100 flex items-center justify-center">
                        <div class="bg-blue-600 p-3 rounded-full z-40">
                          <svg class="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M10 10a4 4 0 100-8 4 4 0 000 8zm-6 8a6 6 0 0112 0H4z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bg-white/80 p-4 z-10">
                  <div class="mt-3 text-center sm:mt-5">
                      <DialogTitle as="h3" class="text-base font-light text-gray-600">
                        {{ $gettext("Calcul du profil de risque en cours") }}
                        <span class="dots"></span>
                      </DialogTitle>
                    </div>
                  <div class="mt-5 sm:mt-6">
                    <button type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0" @click="$emit('cancel')" ref="cancelButtonRef">Cancel</button>
                  </div>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>

<script setup>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue";

const props = defineProps({
  open: {
    type: Boolean,
    required: true
  }
});

const open = props.open;
</script>

<style scoped>
@keyframes dots {
  0% {
    content: '';
    opacity: 0;
  }
  10% {
    content: '.';
    opacity: 1;
  }
  30% {
    content: '..';
  }
  50% {
    content: '...';
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    content: '';
  }
}

.dots::after {
  content: '';
  animation: dots 2s infinite steps(4, end);
  display: inline-block;
  width: 1em; /* optional, prevents layout shift */
  text-align: left;
}
</style>
